<template>
  <div ref="scenarios" class="scenario-list">
    <h2 v-if="title" class="title">
      {{ displayTitle }}
    </h2>
    <div class="list">
      <div v-for="scenario in scenarioList" :key="scenario.id" :class="textPositionClass" class="item">
        <div v-if="!scenario.loaded" class="skeleton-cover2 cover">
          <!--  -->
        </div>
        <RouterLink v-if="scenario.loaded" v-cover-loader
                    :data-src="scenario.cover"
                    :data-default-src="'/img/img-default/img-scenario-default.jpg'"
                    :to="{ name: 'scenarioById', params: { locale: $i18n.localePath(), id: scenario.id }}"
                    :aria-label="displayLocaleTitle(scenario)"
                    class="cover"
                    @click.native="scenarioOnClick(scenario)"
        >
          <!--  -->
        </RouterLink>
        <div :class="textPositionClass" class="subject">
          <RouterLink v-if="scenario.loaded" :to="{ name: 'scenarioById', params: { id: scenario.id }}" class="link-text">
            {{ displayLocaleTitle(scenario) }}
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CoverLoader from '@/directives/CoverLoader'
import ScenarioService from '@/assets/services/ScenarioService'
import { displayLocaleTitle } from '@/assets/helpers/ScenarioHelper.js'

export default {
  name: 'ListenScenarioList',
  components: {},
  directives: {
    CoverLoader
  },
  props: {
    title: {
      type: String,
      default: 'COMMON.SCENARIO'
    },
    textPosition: {
      type: String,
      default: 'OUTSIDE' // OUTSIDE, INSIDE
    },
    assignedIdAry: {
      type: Array,
      default: () => []
    },
    placeholderNum: {
      type: Number,
      default: 8
    }
  },
  data() {
    return {
      scenarioList: []
    }
  },
  computed: {
    displayTitle() {
      return this.$te(this.title)
        ? this.$t(this.title)
        : this.title
    },
    textPositionClass() {
      return this.textPosition.toLowerCase() // inside or outside
    }
  },
  created() {
    // initial empty data
    for (let i = 0; i < this.placeholderNum; i++) {
      this.scenarioList.push({ loaded: false })
    }
    // this.getScenarioList()
  },
  mounted() {
    window.addEventListener('scroll', this.onScrollCheck)
    this.onScrollCheck()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScrollCheck)
  },
  methods: {
    displayLocaleTitle,
    onScrollCheck() {
      const windowHeight = window.innerHeight || document.documentElement.clientHeight
      const windowPageYOffset = window.pageYOffset
      const bundle = this.$refs.scenarios.getBoundingClientRect()
      if (windowHeight + windowPageYOffset > bundle.top) {
        this.getScenarioList()
        window.removeEventListener('scroll', this.onScrollCheck)
      }
    },
    loadCover(coverSrc) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.src = coverSrc
        img.onload = () => {
          resolve(img)
        }
        img.onerror = () => {
          // reject(img)
          resolve()
        }
      })
    },
    async getScenarioList() {
      let scenarioList = []
      if (this.assignedIdAry && this.assignedIdAry.length === 0) {
        scenarioList = await ScenarioService.getScenariosList(null, null, 1, 8)
      } else {
        const q = {
          'id': this.assignedIdAry
        }
        scenarioList = await ScenarioService.getScenariosList(q)
      }

      if (scenarioList && scenarioList.data) {
        const imgList = scenarioList.data.map(scenario => scenario['file_cover_link'])
        const promiseList = imgList.map(imgItem => this.loadCover(imgItem))
        const results = await Promise.all(promiseList)
        scenarioList.data.map((scenario, index) => {
          scenario.loaded = true
          scenario.cover = (results[index] && results[index].src) || require('@/assets/images/scenario/default.png')
        })
        scenarioList.data.sort((a, b) => {
          return this.assignedIdAry.indexOf(a.id) - this.assignedIdAry.indexOf(b.id)
        })
        this.scenarioList = scenarioList.data
      }
    },
    displayScenarioCover(scenario) {
      return { 'background-image': `url(${scenario.cover})` }
    },
    scenarioOnClick(scenario) {
      // console.log(`scenario ${scenario.id} on click`)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.title {
  margin: 16px 0;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.63;
  letter-spacing: normal;
  color: $grey-50;
}
.list {
  display: block;
  margin: 0 -18px;
  .item {
    position: relative;
    display: inline-block;
    width: calc(25% - 36px);
    margin: 0 18px;
    text-decoration: none;
    &.outside {
      margin-bottom: 24px;
    }
    &.inside {
      margin-bottom: 36px;
    }
    .cover {
      display: block;
      padding-top: 89%;
      border-radius: 12px;
      background-color: $grey-ec;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      cursor: pointer;
    }
    .subject {
      width: 100%;
      text-align: center;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .link-text {
        color: inherit;
        text-decoration: none;
        cursor: pointer;
      }
      &.outside {
        height: 32px;
        margin-top: 12px;
        font-size: 20px;
        line-height: 1.6;
        letter-spacing: -0.1px;
        color: $grey-50;
      }
      &.inside {
        position: absolute;
        bottom: 15%;
        height: 26px;
        padding: 0 16px;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.63;
        color: #ffffff;
      }
    }
  }
}

@media only screen and (min-width: 1440px) {
 // As default
}

@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  //
}

@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  //
}

@media only screen and (max-width: 767.98px) {
  .list {
    margin: 0 -12px;
    .item {
      width: calc(50% - 24px);
      margin: 0 12px;
      &.outside,
      &.inside {
        margin-bottom: 24px;
      }
      .subject {
        margin: 8px 0;
        font-size: 16px;
        line-height: 1.63;
        color: $grey-7d;
      }
    }
  }
}

</style>
